module.exports = __webpack_public_path__ + "img/Newbie_Dagger_01_Ranger.ad2fcb12.png";